let googleFontsSingleton;
let googleFontsList;

const loadedFontsFamily = new Set();
const googleFontsUrl = 'https://fonts.googleapis.com/css2?family=';

let pendingStylesheetPromise = Promise.resolve();
let isStylesheetLoading = false;

function getFontsQueryStr() {
  return Array.from(loadedFontsFamily.values())
    .map(encodeURI)
    .join('&family=')
    .replace(/lobster/, 'Lobster')
    .replace(/raleway/, 'Raleway')
    .replace(/lato/, 'Lato');
}

function getGoogleFontsLinkElement() {
  let googleFontsLinkElement = document.getElementById('f-google-fonts-link');

  if (!googleFontsLinkElement) {
    googleFontsLinkElement = document.createElement('link');
    googleFontsLinkElement.id = 'f-google-fonts-link';
    googleFontsLinkElement.rel = 'stylesheet';
    document.getElementsByTagName('head')[0].appendChild(googleFontsLinkElement);
  }

  return googleFontsLinkElement;
}

function loadGoogleFontsStylesheet(href) {
  const linkEl = getGoogleFontsLinkElement();

  if (!isStylesheetLoading && linkEl.dataset.loadedHref === href) {
    return Promise.resolve();
  }

  isStylesheetLoading = true;

  const stylesheetPromise = new Promise((resolve) => {
    const cleanup = () => {
      linkEl.removeEventListener('load', onLoad);
      linkEl.removeEventListener('error', onError);
    };

    const onLoad = () => {
      cleanup();
      isStylesheetLoading = false;
      linkEl.dataset.loadedHref = linkEl.href;
      resolve();
    };

    const onError = () => {
      if (linkEl.href !== href) {
        return;
      }

      cleanup();
      isStylesheetLoading = false;
      resolve();
    };

    linkEl.addEventListener('load', onLoad, {once: true});
    linkEl.addEventListener('error', onError, {once: true});
    linkEl.href = href;
  });

  pendingStylesheetPromise = stylesheetPromise;

  return stylesheetPromise;
}

function createGoogleFontsSingleton() {
  return {
    loadFonts(fonts) {
      if (typeof document === 'undefined') {
        return Promise.resolve();
      }

      const fontsToLoad = Array.isArray(fonts) ? fonts : [fonts];
      let changesNeeded = false; //note: tracks whether we need any new fonts

      fontsToLoad.forEach(fontFamily => {

        if (!fontFamily || loadedFontsFamily.has(fontFamily) || googleFontsList && !googleFontsList.includes(fontFamily)) {
          return;
        }

        changesNeeded = true;
        loadedFontsFamily.add(fontFamily);
      });

      if (!loadedFontsFamily.size) {
        return pendingStylesheetPromise;
      }

      const googleFontsHref = `${googleFontsUrl}${getFontsQueryStr()}`;

      if (!changesNeeded) {
        if (!isStylesheetLoading && getGoogleFontsLinkElement().dataset.loadedHref !== googleFontsHref) {
          return loadGoogleFontsStylesheet(googleFontsHref);
        }

        return pendingStylesheetPromise;
      }

      return loadGoogleFontsStylesheet(googleFontsHref);
    },

    parseFontString(fontString) {
      const family = fontString.split(':')[0];
      const style = fontString.match(/:ital,?/g) ? 'italic' : null;
      const weight = (() => {
        const matchedWeight = fontString.match(/(?!@)(?!1,)(\d+)/g);
        if (matchedWeight) {
          return matchedWeight[0];
        }
      })();

      const parsedFontString = {
        name: fontString,
        displayName: `${family} ${style || ''} ${weight || ''}`.trim(),
        family,
        weight,
        style,
        css: {
          fontFamily: family
        }
      };

      if (weight) {
        parsedFontString.css.fontWeight = weight;
      }

      if (style) {
        parsedFontString.css.fontStyle = style;
      }

      return parsedFontString;
    }
  };
}

export function useGoogleFonts() {
  if (!googleFontsSingleton) {
    googleFontsSingleton = createGoogleFontsSingleton();
  }

  return googleFontsSingleton;
}
